module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_vm._v("Materials")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drawing and sketching")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using colour")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Linear perspective")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aerial perspective")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snow Scene")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glencoe")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boats at Bosham Quay")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cromford Canal")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farm Buildings")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grange in Borrowdale")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baslow Edge")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f003-02.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 78
// module chunks = 0